import { ApiClient } from './ApiClient';

export const getUserSettings = (userId) => ApiClient.get('/user/settings', { params: { userId } });
export const updateSettings = (payload) => ApiClient.put('/user/updateSettings', payload);
